import React, { Component } from "react";
import { Button } from "@material-ui/core";
import MainCategorylist from "../../../../common/category/main-category";
import Loader from "../../../../loader";
import { GetProductDetails } from "../../../../services";
import { NotificationManager } from "react-notifications";
import swal from "sweetalert";

export default class Newproduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategoryIds: [],
      blockhide: false,
      isLoaded: false,
      name: "",
      slug: "",
      status: 1,
      image: "",
      sortDesc: null,
      height: "",
      width: "",
      tags: "",
      stitches: "",
      variants: [],
      predefinedVariantNames: [
        "DST-BERNINA-14x8",
        "DST-BROTHER-V3SE-12x8",
        "DST-FULL",
        "JEF-USHA-450-11x8",
        "JEF-USHA-550-14x8",
        "PES-BROTHER-BP3600-14x9.5",
      ], // Example predefined variant names
    };
  }

  handleBack() {
    this.props.history.goBack();
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onFileChange = (event) => {
    this.setState({ image: event.target.files[0] });
  };

  handleContentChange = (contentHtml) => {
    this.setState({ content: contentHtml });
  };

  handleCategory = (value) => {
    // value should be {id, name} from MainCategorylist
    if (!this.state.selectedCategoryIds.some((cat) => cat.id === value.id)) {
      this.setState((prevState) => ({
        selectedCategoryIds: [...prevState.selectedCategoryIds, value],
        blockhide: true,
      }));
    }
  };

  handleRemoveCategory = (categoryId) => {
    this.setState((prevState) => ({
      selectedCategoryIds: prevState.selectedCategoryIds.filter(
        (cat) => cat.id !== categoryId,
      ),
    }));
  };

  handleAddVariant = () => {
    this.setState((prevState) => ({
      variants: [
        ...prevState.variants,
        { variantName: "", variantPrice: 0, variantPath: "" },
      ],
    }));
  };

  handleRemoveVariant = (index) => {
    this.setState((prevState) => ({
      variants: prevState.variants.filter((_, i) => i !== index),
    }));
  };

  // handleVariantChange = (index, e) => {
  //   const { name, value } = e.target;
  //   const newVariants = [...this.state.variants];
  //   newVariants[index] = { ...newVariants[index], [name]: value };
  //   this.setState({ variants: newVariants });
  // };

  handleVariantChange = (index, e) => {
    const { name, value } = e.target;
    const newVariants = [...this.state.variants];

    // Auto append .zip for variantPath
    if (name === "variantPath") {
      let fileName = value.trim();

      // Remove existing .zip if user types it
      if (fileName.toLowerCase().endsWith(".zip")) {
        fileName = fileName.slice(0, -4);
      }

      // Always append .zip
      fileName = `${fileName}.zip`;

      newVariants[index] = {
        ...newVariants[index],
        [name]: fileName,
      };
    } else {
      newVariants[index] = {
        ...newVariants[index],
        [name]: value,
      };
    }

    this.setState({ variants: newVariants });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const {
      selectedCategoryIds,
      image,
      name,
      slug,
      status,
      sortDesc,
      variants,
      height,
      width,
      tags,
      stitches,
    } = this.state;

    // Validation
    if (
      !selectedCategoryIds.length ||
      !name ||
      !slug ||
      !image ||
      !sortDesc ||
      !height ||
      !stitches ||
      !width ||
      !tags ||
      variants.length === 0
    ) {
      NotificationManager.error(
        "All fields are required and at least one variant must be added.",
        "Validation Error",
      );
      return;
    }

    const combinedHeight = `Height ${height}, Width ${width}`;

    // Handle stitches logic: Check if it's a single value or multiple values
    let formattedStitches;
    const stitchesArray = stitches.split(",").map((stitch) => stitch.trim()); // Split by comma and remove extra spaces

    if (stitchesArray.length === 1) {
      // Single stitch value
      formattedStitches = stitchesArray[0]; // Send it directly
    } else if (stitchesArray.length === 2) {
      // Two stitch values
      formattedStitches = `Back ${stitchesArray[0]}, Hand ${stitchesArray[1]}`; // Format it as needed
    } else {
      // Invalid format for stitches, return error
      NotificationManager.error(
        "Stitches must be a single value or two values separated by a comma.",
        "Validation Error",
      );
      return;
    }

    // Validate variant data
    const invalidVariants = variants.some(
      (variant) => !variant.variantName || !variant.variantPrice,
    );
    if (invalidVariants) {
      NotificationManager.error(
        "All variants must have a name and a price.",
        "Validation Error",
      );
      return;
    }

    this.setState({ isLoaded: true });
    const formData = new FormData();
    formData.append(
      "categoryIds",
      JSON.stringify(selectedCategoryIds.map((cat) => cat.id)),
    );

    formData.append("name", name);
    formData.append("slug", slug);
    formData.append("status", status);
    formData.append("sortDesc", sortDesc);
    formData.append("height", combinedHeight);
    formData.append("stitches", formattedStitches); // Append formatted stitches field
    formData.append("tags", tags); // Append tags field
    formData.append("photo", image);

    // Append variants data
    variants.forEach((variant, index) => {
      formData.append(`variants[${index}][variantName]`, variant.variantName);
      formData.append(`variants[${index}][variantPrice]`, variant.variantPrice);
      formData.append(`variants[${index}][variantPath]`, variant.variantPath);
    });

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    swal({
      title: "Are you sure?",
      text: "You want to Add New Product",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (success) => {
      if (success) {
        let list = await GetProductDetails.addProductList(formData, config);
        if (list) {
          this.setState({ isLoaded: false });
          this.props.history.push("/admin/product/list");
        } else {
          NotificationManager.error("Please! Check input field", "Input Field");
        }
      }
    });
  };

  render() {
    const { isLoaded, variants, predefinedVariantNames, selectedCategoryIds } =
      this.state;
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5 col-md-9 col-lg-6">
            <h2 className="mt-30 page-title">Products</h2>
          </div>
          <div className="col-lg-5 col-md-3 col-lg-6 back-btn">
            <Button variant="contained" onClick={(e) => this.handleBack()}>
              <i className="fas fa-arrow-left" /> Back
            </Button>
          </div>
        </div>
        <ol className="breadcrumb mb-30">
          <li className="breadcrumb-item">
            <a href="/">Dashboard</a>
          </li>
          <li className="breadcrumb-item">
            <a href="/admin/product/create">Products</a>
          </li>
          <li className="breadcrumb-item active">Add Product</li>
        </ol>

        <div className="row">
          <div className="col-lg-6 col-md-6">
            <div className="card card-static-2 mb-30">
              <div className="card-body-table">
                <div className="news-content-right pd-20">
                  <div className="form-group">
                    <label className="form-label">Category*</label>
                    <MainCategorylist
                      selectedCategories={selectedCategoryIds}
                      handleCategorySelect={this.handleCategory}
                      handleCategoryRemove={this.handleRemoveCategory}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "8px",
                        marginTop: "10px",
                      }}
                    >
                      {selectedCategoryIds.map((cat, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            background: "#e3f2fd",
                            color: "#1565c0",
                            padding: "6px 10px",
                            borderRadius: "20px",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {cat.name}
                          <Button
                            size="small"
                            onClick={() => this.handleRemoveCategory(cat.id)}
                            style={{ marginLeft: "6px", color: "red" }}
                          >
                            Remove
                          </Button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="row"
          style={
            this.state.blockhide ? { display: "block" } : { display: "none" }
          }
        >
          {isLoaded && <Loader />}
          <div className="col-lg-12 col-md-12">
            <div className="card card-static-2 mb-30">
              <div className="card-title-2">
                <h4>Add New Product</h4>
              </div>
              <div className="card-body-table">
                <div className="news-content-right pd-20">
                  <div className="row">
                    <div className="col-lg-2 col-md-2">
                      <div className="form-group">
                        <label className="form-label">Product Name*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Product Name"
                          name="name"
                          value={this.state.name}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                      <div className="form-group">
                        <label className="form-label">Slug*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Slug"
                          name="slug"
                          value={this.state.slug}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                      <div className="form-group">
                        <label className="form-label">Category Image*</label>
                        <input
                          type="file"
                          className="form-control"
                          name="image"
                          onChange={this.onFileChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ paddingTop: "2rem" }}>
                    <div className="col-lg-2 col-md-2">
                      <div className="form-group">
                        <label className="form-label">Status*</label>
                        <select
                          id="status"
                          name="status"
                          className="form-control"
                          value={this.state.status}
                          onChange={(e) => this.handleChange(e)}
                        >
                          <option value={1}>Active</option>
                          <option value={0}>Inactive</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                      <div className="form-group">
                        <label className="form-label">Height*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Height (e.g., 6x4)"
                          name="height"
                          value={this.state.height}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                      <div className="form-group">
                        <label className="form-label">Width*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Height (e.g., 6x4)"
                          name="width"
                          value={this.state.width}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                      <div className="form-group">
                        <label className="form-label">Stitches*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Stitches (e.g., 17000, 8880)"
                          name="stitches"
                          value={this.state.stitches}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                      <div className="form-group">
                        <label className="form-label">Tags*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Tags (e.g., god, peacock)"
                          name="tags"
                          value={this.state.tags}
                          onChange={(e) => this.handleChange(e)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row" style={{ paddingTop: "2rem" }}>
                    <div className="form-group">
                      <label className="form-label">Sort Description*</label>
                      <textarea
                        rows="4"
                        cols="100"
                        className="form-control"
                        name="sortDesc"
                        value={this.state.sortDesc}
                        onChange={(e) => this.handleChange(e)}
                      />
                    </div>
                  </div>

                  {/* Variants Section */}
                  <div className="variants-section">
                    <h4>Product Variants</h4>
                    <div
                      style={{
                        background: "#e3f2fd",
                        border: "1px solid #90caf9",
                        padding: "10px 14px",
                        borderRadius: "6px",
                        marginBottom: "15px",
                        color: "#0d47a1",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      📦 Variant File Rule: Enter <b>file name only</b> —{" "}
                      <b>.zip will be added automatically</b>
                      <br />
                      Example: <i>DST-BERNINA-14x8</i> →{" "}
                      <i>DST-BERNINA-14x8.zip</i>
                    </div>
                    {variants.map((variant, index) => (
                      <div className="row" key={index}>
                        <div className="col-lg-3 col-md-3">
                          <div className="form-group">
                            <label className="form-label">Variant Name*</label>
                            <select
                              className="form-control"
                              name="variantName"
                              value={variant.variantName}
                              onChange={(e) =>
                                this.handleVariantChange(index, e)
                              }
                            >
                              <option value="">Select Variant</option>
                              {predefinedVariantNames.map((name, i) => (
                                <option key={i} value={name}>
                                  {name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-2">
                          <div className="form-group">
                            <label className="form-label">Variant Price*</label>
                            <input
                              type="number"
                              className="form-control"
                              name="variantPrice"
                              value={variant.variantPrice}
                              onChange={(e) =>
                                this.handleVariantChange(index, e)
                              }
                              placeholder="Variant Price"
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-3">
                          <div className="form-group">
                            <label className="form-label">
                              Variant File Name*
                            </label>

                            <input
                              type="text"
                              className="form-control"
                              name="variantPath"
                              value={variant.variantPath}
                              onChange={(e) =>
                                this.handleVariantChange(index, e)
                              }
                              placeholder="Variant File Name"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <div className="form-group">
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={() => this.handleRemoveVariant(index)}
                            >
                              Remove Variant
                            </Button>
                          </div>
                        </div>
                      </div>
                    ))}
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleAddVariant}
                    >
                      Add Variant
                    </Button>
                  </div>

                  <div className="button_price">
                    <div className="form-group" style={{ display: "block" }}>
                      <button
                        className="save-btn hover-btn"
                        type="submit"
                        onClick={this.handleSubmit}
                      >
                        Add New Product
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/product/new-add/index.js